import { createContext } from 'react'

const PageManagerContext = createContext()

export default PageManagerContext
